import CreateLinkContainer from "../containers/CreateLinkContainer";

const CreateLinkPage = () => {
  return (
    <CreateLinkContainer />
  );
};

export default CreateLinkPage;
